import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/auth/AuthContext";

export const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { user, isChecking } = useAuth();
  const location = useLocation();

  if (isChecking) {
    return (
      <div className="h-[60vh] grain-bg flex items-center justify-center">
        <div className="w-12 h-12 rounded-full border-4 border-[#E2DACB] border-t-[#557448] animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  if (adminOnly && !user.is_admin) return <Navigate to="/dashboard" replace />;
  return children;
};
